/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const AgentAdminIcon: React.SFC = () => {
    return (
        <svg className="AgentAdminIcon" viewBox="0 0 20 24" width="20" height="24">
        <path fillRule="evenodd" clipRule="evenodd" fill="#4F73AF" className="st0" d="M10 24C20.3 24 20 3.9 20 3.9 14.1 3.9 10 0 10 0S5.9 3.9 0 3.9C0 3.9-.3 24 10 24z"/>
        <circle fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" className="st1" cx="10" cy="8" r="3"/>
        <path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" className="st1" d="M15.1 17.1c0 2.8-2.3 1.7-5.1 1.7s-5.1 1.1-5.1-1.7S7.2 12 10 12s5.1 2.3 5.1 5.1z"/>
        </svg>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/AgentAdmin/AgentAdmin.tsx